import React, { Component } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import logo from "../assets/Images/pngwing.com.png";
import { Home } from "../Pages/Home/Home";
import {
  Project,
  ProjectHeading,
  SmallProject,
  SmallHeading,
} from "./Project/Project";
import Blog from "../Component/Blog/Blog";
import { Contact, Skill, MyFun, ContactInfo } from "../Pages/Contact/Contact";
import "../Css/Nav.css";

export default class Navibar extends Component {
  render() {
    return (
      <Router>
        <Navbar expand="lg" className="nav-bg-body fixed-top">
          <Container>
            <Navbar.Brand href="/">
              <img
                src={logo}
                alt="Logo"
                width="30"
                height="30"
                className="d-inline-block align-top"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto nav-text-white font-face-gm">
                <Nav.Link as={Link} to="/">
                  #Home
                </Nav.Link>
                <Nav.Link as={Link} to="/project">
                  #Project
                </Nav.Link>
                <Nav.Link as={Link} to="/contact">
                  #Contact
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div style={{ marginTop: "20px" }}>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Home />
                </>
              }
            />
            <Route
              path="/project"
              element={
                <>
                  <ProjectHeading />
                  <Project />
                  <SmallHeading />
                  <SmallProject />
                </>
              }
            />
            <Route path="/blog" element={<Blog />} />
            <Route
              path="/contact"
              element={
                <>
                  <Contact />
                  <Skill />
                  <ContactInfo />
                  <MyFun />
                </>
              }
            />
          </Routes>
        </div>
      </Router>
    );
  }
}
